import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.custom-testimonials';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      if (!query.data) return;

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        const star = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="1.87 2.33 16.27 15.65">   <g clip-path="url(#clip0_8172_212)">     <path d="M10.3439 15.3784L14.2814 17.8784C14.7892 18.1987 15.4142 17.7222 15.2657 17.1362L14.1251 12.6519C14.0943 12.5276 14.0992 12.3971 14.1393 12.2755C14.1793 12.1538 14.253 12.046 14.3517 11.9644L17.8829 9.01906C18.3439 8.63625 18.1095 7.86281 17.5079 7.82375L12.8986 7.52687C12.7728 7.51956 12.6519 7.47576 12.5506 7.40084C12.4493 7.32592 12.372 7.22312 12.3282 7.105L10.6095 2.77687C10.564 2.6518 10.4811 2.54375 10.3721 2.4674C10.2631 2.39105 10.1332 2.3501 10.0001 2.3501C9.86702 2.3501 9.73715 2.39105 9.62814 2.4674C9.51912 2.54375 9.43624 2.6518 9.39074 2.77687L7.67199 7.105C7.62819 7.22312 7.55092 7.32592 7.44964 7.40084C7.34836 7.47576 7.22745 7.51956 7.10168 7.52687L2.49231 7.82375C1.89074 7.86281 1.65637 8.63625 2.11731 9.01906L5.64856 11.9644C5.74726 12.046 5.82089 12.1538 5.86097 12.2755C5.90106 12.3971 5.90596 12.5276 5.87512 12.6519L4.82043 16.8081C4.64074 17.5112 5.39074 18.0816 5.99231 17.6987L9.65637 15.3784C9.75912 15.3131 9.87836 15.2784 10.0001 15.2784C10.1219 15.2784 10.2411 15.3131 10.3439 15.3784Z" fill="#FF0033"></path>   </g>   <defs>     <clipPath id="clip0_8172_212">       <rect width="20" height="20" fill="white" transform="translate(0 0.47998)"></rect>     </clipPath>   </defs> </svg>';

        const starsHTML = star.repeat(item.stars || 0);

        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="nFlex">
            ${item.testimonial ? `<p class="testimonial-text">${item.testimonial}</p>` : ''}
              <div class="details-wrapper">
              ${item.photo ? `<div class="image-wrapper">
                <img src="${item.photo}" alt="${item.name}">
              </div>` : ''}
                <div class="name-wrapper">
                  <h4 class="name">${item.name}</h4>
                  <div class="stars" data-stars="${item.stars}">${starsHTML}</div>
                </div>
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
(() => {
  document.querySelectorAll('.custom-testimonials .splide').forEach((item) => {
    const moreThanFour = item.querySelectorAll('.splide__slide').length > 4;
    const slider = new Splide(item, {
      type: 'slide',
      rewind: true,
      perPage: 4,
      perMove: 1,
      gap: 20,
      pagination: true,
      drag: moreThanFour,
      arrows: false,
      autoplay: true,
      breakpoints: {
        1200: {
          drag: true,
          perPage: 3,
        },
        991: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
